export default __webpack_public_path__ + "static/media/youtube-icon.600e32b0.svg";